import { React, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Switch, Typography } from '@mui/material';
import { useDispatch, useSelector } from '../../../../redux/store';
import { facilityModeToggleChange, getInvoiceBreakdown } from '../../../../redux/slices/invoicing';
import { useSnackbar } from '../../../../reusable-components/snackbar';
import { useIsInvoiceEditable } from './reusable/hooks/useInvoiceLocks';

MultiFacilityToggle.propTypes = {};
export default function MultiFacilityToggle() {
  const { id } = useParams();

  const dispatch = useDispatch();
  const {
    data: { invoiceItemData },
  } = useSelector((state) => state.invoicing);
  const { invoice = null } = invoiceItemData || {};
  const { facilityId = 0, multiFacility = 0 } = invoice || {};
  const { isEditable: hasEditAccess } = useIsInvoiceEditable(); 
  const { enqueueSnackbar } = useSnackbar();
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    setChecked(multiFacility);
  }, [multiFacility]);

  const handleSwitchChange = (event, value) => {
    handleToggleFacilityMode(value ? 'multi' : 'single');
  };

  const handleToggleFacilityMode = async (mode) => {
    const response = await dispatch(facilityModeToggleChange(id, mode));

    enqueueSnackbar(response.message ? response.message : 'Error updating invoice mode.', {
      variant: response.success ? 'success' : 'error',
      persist: response.keepFormOpen,
    });
    if (response.success) dispatch(getInvoiceBreakdown(id, (mode = 'ItemsLog')));
  };
  return (
    <>
      <Box sx={{ mt: 3 }}>
        <Box sx={mainBoxStyle}>
          <Typography sx={{ color: '#060606', fontSize: '16px', fontWeight: '700' }}>Multi facility invoice</Typography>
          <Switch checked={checked} onChange={handleSwitchChange} disabled={!hasEditAccess || facilityId === 0} />
        </Box>
      </Box>
    </>
  );
}

const mainBoxStyle = {
  borderRadius: '4px',
  boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
  backgroundColor: '#fff',
  padding: '10px 25px',
  overflow: 'auto',
  border: 'solid 1px #c1c9d0',
  display: 'flex',
  alignItems: 'center',
  marginBottom: '5px',
};
